<template>
  <b-container fluid>
    <ConfiguratorStepTitle :step="configuratorStepNumber" title="DETALLES GENERALES" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
            <b-row class="mb-4">
              <ValidationProvider rules="required" name="Nombre" style="width: 100%" v-slot="{ valid, errors }">
                <Label label="Nombre" :blank="submitalForm.title" show-reset @reset="submitalForm.title = null" />
                <b-input-group size="lg">
                  <b-input
                    v-model="submitalForm.title"
                    type="text"
                    :state="errors[0] ? false : (valid ? true : false)"
                    trim
                    @blur="updateSubmital"
                  />
                </b-input-group>
              </ValidationProvider>
            </b-row>
            <b-row class="mb-4">
              <ValidationProvider :rules="{ required: true, numeric: true, min_value: 1 }" name="cantidad" style="width: 100%" v-slot="{ valid, errors }">
                <Label label="Cantidad de unidades idénticas" :blank="submitalForm.quantity" show-reset @reset="submitalForm.quantity = null" />
                <b-input-group size="lg">
                  <b-input
                    v-model.number="submitalForm.quantity"
                    type="number"
                    :state="errors[0] ? false : (valid ? true : false)"
                    min="1"
                    max="100"
                    step="1"
                    @blur="updateSubmital"
                  />
                </b-input-group>
              </ValidationProvider>
            </b-row>

            <b-row class="flex-column">
              <Label label="Comentarios" :blank="form.notes" show-reset @reset="form.notes = null" />
              <b-textarea
                v-model="form.notes"
                rows="10"
                trim
                size="lg"
                class="mt-2 notes-textarea"
              />
            </b-row>
            <span class="d-none">{{ invalid }}</span>
          </ValidationObserver>
        </b-col>
      </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import Label from '../Label'

export default {
  name: 'General',
  components: {
    ConfiguratorStepTitle,
    ValidationObserver,
    ValidationProvider,
    Label
  },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      processing: false,
      submitalForm: {
        title: '',
        quantity: 1
      },
      form: {
        notes: ''
      }
    }
  },
  mounted () {
    if (this.submital) {
      this.submitalForm.title = this.submital.title
      this.submitalForm.quantity = this.submital.quantity
    }

    const generico = this.generico
    if (generico) {
      this.form.notes = generico.notes
    }
  },
  computed: {
    ...mapState({
      generico: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    }),
    ...mapGetters(['configuratorStepNumber'])
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable({
        generico: this.form
      })

      return result
    },
    updateSubmital () {
      this.submitalForm.quantity = this.submitalForm.quantity > 1 ? this.submitalForm.quantity : 1

      this.$emit('update-submital', this.submitalForm)
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.generico[key])
    }
  }
}
</script>

<style scoped>
  .notes-textarea {
    outline: 1px solid black;
    outline-offset: 5px;
    background-color: #faf8c6;
    border: 0px;
  }
  .notes-textarea:focus {
    outline: 1px solid #163D7D;
    outline-offset: 5px;
    border: 0px;
  }
  .notes-textarea:disabled {
    background-color: #edeccc;
  }
  .notes-textarea:disabled:hover {
    cursor: not-allowed;
  }
</style>
